import React, { useEffect, useState } from "react";
import OtpInput from "react-otp-input";

import AuthLayout from "./AuthLayout";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../components/Button";
import { Box, FormControl, Typography } from "@mui/material";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { useAppDispatch } from "../../hooks/store";
import { temporaryToken } from "../../reducers/authSlice";
import {
  usePostVerifyOtpMutation,
  useResendOtpMutation,
} from "../../service/auth";
import { errorToast, setToStorage, successToast } from "../../helpers";
import { STORAGE_KEYS } from "../../constants/storageKeys";

const otpStyle = {
  width: "60px",
  height: "60px",
  "box-sizing": "border-box",

  fontSize: "20px",
  color: "black",
  lineHeight: "50px",
};

const Verification = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [otp, setOtp] = useState("");
  const [countDown, setCountDown] = useState<number>(59);

  const [optVerificationMutation] = usePostVerifyOtpMutation();
  const [resendOtpMutation] = useResendOtpMutation();

  const handleSubmit = async () => {
    if (otp?.length != 4) {
      errorToast("Please enter one time password");
      return;
    }
    if (otp?.length === 4) {
      const body = {
        email: state?.email,
        otp,
      };
      try {
        const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        const response = await optVerificationMutation(encryptedBody).unwrap();
        if (response?.status === 200) {
          dispatch(temporaryToken({ tempToken: response?.data?.token }));
          setToStorage(STORAGE_KEYS.tempToken, response?.data?.token);
          successToast("OTP verified successfully");
          navigate("/reset-password", {
            replace: true,
          });
        }
      } catch (error: any) {
        if (error?.data?.message) {
          errorToast(error?.data?.message || "");
          setOtp("");
        }
      }
    }
  };

  const handleResendOtp = async (e: any) => {
    e.preventDefault();
    const body = {
      email: state?.email,
    };

    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await resendOtpMutation(encryptedBody).unwrap();
      if (response?.status === 200) {
        setOtp("");
        successToast("OTP sent successfully");
        setCountDown(59);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
    }
  };

  useEffect(() => {
    if (countDown > 0) {
      setTimeout(() => {
        setCountDown(countDown - 1);
      }, 1000);
    } else {
      setCountDown(0);
    }
  }, [countDown]);

  return (
    <AuthLayout>
      <div className="authBox">
        <h2>Verify OTP</h2>
        <p>Please enter the OTP sent to your email</p>
        <form>
          <FormControl
            className="opt_fields otp_fld"
            sx={{
              width: "100%",
              marginBottom: "40px",
            }}
          >
            <OtpInput
              value={otp}
              onChange={setOtp}
              numInputs={4}
              renderInput={(props: any) => <input {...props} />}
              inputStyle={otpStyle}
              inputType="tel"
              shouldAutoFocus
            />
          </FormControl>

          <Button value="Verify" onClick={handleSubmit} />
        </form>
        {countDown === 0 ? (
          <Box
            sx={{
              textAlign: "center",
              pt: 2,
            }}
          >
            <Typography
              className="anchor_link"
              sx={{
                cursor: "pointer",
                color: "#9988C5",
              }}
            >
              Didn't receive OTP?
              <span className="resend_btn" onClick={handleResendOtp}>
                {" "}
                Resend OTP
              </span>
            </Typography>
          </Box>
        ) : (
          <Box>
            <Typography
              sx={{
                pt: 2,
                display: "flex",
                justifyContent: "center",
                position: "relative",
                marginLeft: "-40px",
              }}
            >
              The verification code will expire in{" "}
              {countDown < 10 ? (
                <span
                  style={{
                    margin: 0,
                    right: "65px",
                    position: "absolute",
                  }}
                >
                  00:0{countDown}
                </span>
              ) : (
                <span
                  style={{
                    margin: 0,
                    right: "65px",
                    position: "absolute",
                  }}
                >
                  00:{countDown}
                </span>
              )}
            </Typography>
          </Box>
        )}
      </div>
    </AuthLayout>
  );
};

export default Verification;
